"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var lodash_1 = require("lodash");
var ChartColors_1 = require("../charts/ChartColors");
var getTablebarCellColor = function (min, max, value) {
    var sequentialBlueColorsArray = Object.values(ChartColors_1.SequentialChartColor.Blue);
    var interval = (max - min) / sequentialBlueColorsArray.length;
    var color;
    var count = 0;
    for (var i = min; i <= max; i = i + interval) {
        if (value >= i && value < i + interval) {
            color = lodash_1.nth(sequentialBlueColorsArray, count);
        }
        count++;
    }
    return color;
};
var styles = {
    container: react_1.css({
        display: 'inline-block',
        overflow: 'hidden',
    }),
    progress: react_1.css({
        // Position a full width inner div with `translateX` instead of setting the `width` because
        // transitions on `transform` properties are much more performant than on layout attributes.
        transition: 'transform 200ms ease',
        width: '100%',
        borderTopRightRadius: 30,
        borderBottomRightRadius: 30,
        height: '100%',
    }),
};
var TableBarCell = function (props) {
    var maxValue = props.maxValue, minValue = props.minValue, progress = props.progress, color = props.color, height = props.height;
    var coerceBetween = function (value, min, max) {
        return Math.max(Math.min(value, max), min);
    };
    return (react_1.jsx("span", { css: styles.container, style: { height: height || 24, width: '100%' } },
        react_1.jsx("div", { css: styles.progress, style: {
                transform: "translateX(" + (coerceBetween(progress, minValue, maxValue) - 100) + "%)",
                backgroundColor: color ? color : getTablebarCellColor(minValue, maxValue, progress),
            } })));
};
exports.default = TableBarCell;
